/**
 * Handles from submission and replace the old form with the new partial
 * @module lib/copy_to_clipboard
 */

export default function copyToClipboard() {
  // attach on page load
  runCopyToClipboard();

  // reattach on turbolinks load
  document.addEventListener('turbolinks:load', () => {
    runCopyToClipboard();
  });

  // reattach on ajax success
  document.addEventListener('ajax:success', () => {
    runCopyToClipboard();
  });

  // reattach on ajax error
  document.addEventListener('ajax:error', () => {
    runCopyToClipboard();
  });
}

function runCopyToClipboard() {
  document.querySelectorAll('[data-copy-to-clipboard]').forEach((element) => {
    if (!element.dataset.attached) {
      // use dataset to know if we need to attach the event listener
      element.dataset.attached = true;

      element.addEventListener('click', (event) => {
        event.preventDefault();
        event.target.blur();
        navigator.clipboard.writeText(element.getAttribute('data-copy-to-clipboard'));
      });
    }
  });
}
